import { useState, useContext } from "react";
import { useNavigate } from "@tanstack/react-router";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useDraftOrderApprovalSend } from "../../hooks/useDraftOrderApprovalSend";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export const SubmitOrder = ({ order, setActiveStep }) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const navigate = useNavigate();

  // Approval
  const {
    mutate: submitOrderApproval,
    isSuccess: approvalIsSuccess,
    data: approvalData,
  } = useDraftOrderApprovalSend();

  // Success Function
  const approvalSuccessFunc = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    navigate({ to: "/submitted-requests" });
  };

  // Error Function
  const approvalErrorFunc = () =>
    setAlertNotification({
      message: `Error: ${approvalData.data.status}: ${approvalData.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(
    approvalIsSuccess,
    approvalData,
    approvalData?.data?.status,
    approvalSuccessFunc,
    approvalErrorFunc,
  );

  const handleSumbitApprovalClick = () => {
    setDisableSubmit(true);
    submitOrderApproval({
      orderNo: order.data.order.no,
      poNo: order.data.order.poNo,
    });
  };

  return (
    <Box sx={{ width: "100%", pt: 2, pb: 2 }}>
      <Typography sx={{ pb: 1 }}>
        Click the button below to submit your request and inform your order
        approver.
      </Typography>
      <Typography sx={{ pb: 2 }}>
        Once submitted, you cannot ammend the request.
      </Typography>
      <Button
        variant="contained"
        onClick={handleSumbitApprovalClick}
        disabled={disableSubmit}
      >
        Submit
      </Button>
    </Box>
  );
};
